import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCompanyFeatureFlag } from '@/hooks/useCompanyFeatureFlag';
import { ROUTES } from '@/lib/routes';
import LoadingSpinner from '@/components/LoadingSpinner';

interface HQRouteGuardProps {
  children: React.ReactNode;
}

/**
 * Wraps HQ routes. When company does not have headquarters_module flag,
 * redirects to dashboard. Avoids exposing HQ pages via direct URL.
 */
const HQRouteGuard: React.FC<HQRouteGuardProps> = ({ children }) => {
  const { enabled, loading } = useCompanyFeatureFlag();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;
    if (!enabled) {
      navigate(ROUTES.dashboard.root, { replace: true });
    }
  }, [enabled, loading, navigate]);

  if (loading) {
    return <LoadingSpinner fullScreen text="載入中..." />;
  }
  if (!enabled) {
    return null;
  }
  return <>{children}</>;
};

export default HQRouteGuard;
